import { styled } from '@mui/material';
import Box from '@mui/material/Box';

const EdoModuleStyledContainer = styled(Box)`
  .card {
    display: flex;
    position: relative;
    gap: 20px;
    flex-direction: column;
  }

  .module-title {
    color: #3460b4;
    font-weight: 500;
    font-size: 16px;
  }

  .other-info-wrapper {
    display: flex;
    position: relative;
    gap: 20px;
  }

  .availability-edo {
    legend {
      font-size: 0.85em !important;
    }
  }
`;

export { EdoModuleStyledContainer };
